<template functional>
    <div class="dml-content-heading" data-t="24.4">
        <span class="dml-content-heading__text">{{props.text}}</span>
    </div>
</template>
<script>
    export default {
        name: 'dm-heading',
        props: {
            text: {
                type: String,
                required: true
            }
        },
    };
</script>
